export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Our Group", to: "/group" },
    { label: "Contact Us", to: "/contact" },
];

export const LOGO_GROUP = "/assets/logo-ms-group-t.png";
export const LOGO_GROUP_WHITE = "/assets/logo-ms-group-t.png";

export const HERO_SLIDES = [
    {
        key: "seeds",
        label: "Agriculture & Hybrid Seeds",
        short: "Hybrid Seeds",
        statement: "Trusted by a million farming families across India.",
        poster: "/assets/videos/seeds.jpg",
        videos: [{ video: "/assets/videos/seeds.mp4", webm: "/assets/videos/seeds.webm", poster: "/assets/videos/seeds.jpg" }],
    },
    {
        key: "fmcg",
        label: "FMCG & Foods",
        short: "Foods",
        statement: "Packaged water, rice, pulses, flours, biscuits — for every Indian home.",
        poster: "/assets/videos/fmcg.jpg",
        videos: [
            { video: "/assets/videos/fmcg.mp4", webm: "/assets/videos/fmcg.webm", poster: "/assets/videos/fmcg.jpg" },
            { video: "/assets/videos/fmcg3.mp4", webm: "/assets/videos/fmcg3.webm", poster: "/assets/videos/fmcg3.jpg" },
        ],
    },
    {
        key: "realty",
        label: "Real Estate",
        short: "Real Estate",
        statement: "Building spaces that grow in value and in trust.",
        poster: "/assets/videos/realty.jpg",
        videos: [
            { video: "/assets/videos/realty.mp4", webm: "/assets/videos/realty.webm", poster: "/assets/videos/realty.jpg" },
        ],
    },
    {
        key: "health",
        label: "Pharma & Healthcare",
        short: "Healthcare",
        statement: "Clinician-led pharma and healthcare for Indian people.",
        poster: "/assets/videos/health.jpg",
        videos: [
            { video: "/assets/videos/health.mp4", webm: "/assets/videos/health.webm", poster: "/assets/videos/health.jpg" },
            { video: "/assets/videos/health2.mp4", webm: "/assets/videos/health2.webm", poster: "/assets/videos/health2.jpg" },
        ],
    },
];

export const SEED_STATS = [
    { end: 1, suffix: " Million+", label: "Farmer Families", sub: "served across Pan India" },
    { end: 500, suffix: "+", label: "Employees", sub: "one growing MS family" },
    { end: 4, suffix: "", label: "Offices", sub: "corporate & regional presence" },
    { end: 5000, suffix: "+", label: "Dealers", sub: "distribution network across India" },
];

export const INDUSTRIES = [
    {
        key: "seeds",
        name: "Agriculture & Hybrid Seeds",
        tag: "Our Foundation",
        image: HERO_SLIDES[0].poster,
        desc: "Research-driven hybrid seeds across field and vegetable crops — the business on which MS Group was founded, and the trust on which it still stands.",
        companies: ["My Seeds", "Navayuga Seeds", "Seven Seeds", "Seed Park"],
    },
    {
        key: "fmcg",
        name: "FMCG",
        tag: "Everyday Essentials",
        image: HERO_SLIDES[1].poster,
        desc: "A complete FMCG basket for Indian households — packaged drinking water, rice, pulses, flours, biscuits and everyday food essentials, made with the discipline of the farm.",
        companies: ["Mega Foods"],
    },
    {
        key: "realty",
        name: "Real Estate",
        tag: "Spaces that Appreciate",
        image: HERO_SLIDES[2].poster,
        desc: "Transparent, well-planned land and development ventures — spaces designed to grow in value and in trust.",
        companies: ["Navayuga Ventures"],
    },
    {
        key: "health",
        name: "Pharma & Healthcare",
        tag: "Care with Integrity",
        image: HERO_SLIDES[3].poster,
        desc: "Pharmaceutical and healthcare specialities led by clinicians — global standards of care for Indian communities.",
        companies: ["Navayuga Healthcare"],
    },
];

export const COMPANIES = [
    {
        id: "my-seeds",
        est: "2014",
        name: "My Seeds",
        sector: "Hybrid Seeds",
        logo: "/assets/logo-myseeds-t.png",
        url: "https://www.myseeds.in",
        color: "#58A618",
        tagline: "The Power of Farmer…",
        desc: "The founding brand of MS Group, established in 2014 — a farmer-first seed label built on accessibility, performance and honest pricing, carrying the power of the farmer to every village gate.",
    },
    {
        id: "navayuga-seeds",
        est: "2015",
        name: "Navayuga Seeds",
        sector: "Hybrid Seeds",
        logo: "/assets/logo-navayuga-seeds-t.png",
        url: "https://www.navayugaseeds.com",
        color: "#2E7D32",
        tagline: "Absolute Trust…",
        desc: "The Group's research-led hybrid seed house, established in 2015 — trusted by farming families across India. For us, Absolute Trust is not a tagline; it is the operating system.",
    },
    {
        id: "seven-seeds",
        est: "2021",
        name: "Seven Seeds",
        sector: "Hybrid Seeds",
        logo: "/assets/logo-seven-seeds-t.png",
        url: "https://www.7seeds.in",
        color: "#4A2C5A",
        tagline: "Smart Cultivation…",
        desc: "A focused hybrid seed label serving progressive growers with dependable, high-performing varieties.",
    },
    {
        id: "seed-park",
        est: "2023",
        name: "Seed Park",
        sector: "Hybrid Seeds",
        logo: "/assets/logo-seed-park-t.png",
        url: "https://www.seedpark.in",
        color: "#F7941D",
        tagline: "farming simplified…",
        desc: "An integrated seed and agri-solutions platform connecting growers, dealers and agronomy expertise — farming, simplified.",
    },
    {
        id: "mega-foods",
        est: "2025",
        name: "Mega Foods",
        sector: "FMCG",
        logo: "/assets/logo-mega-foods-t.png",
        url: null,
        color: "#0F2A5C",
        tagline: "Everyday essentials for every Indian home.",
        desc: "The Group's FMCG house — a full basket of essentials spanning packaged drinking water, rice, pulses, flours, biscuits and more, built with the same discipline that created our seed business.",
    },
    {
        id: "navayuga-ventures",
        est: "2024",
        name: "Navayuga Ventures",
        sector: "Real Estate",
        logo: "/assets/logo-navayuga-ventures-t.png",
        url: null,
        color: "#00A651",
        tagline: "Spaces built on transparency.",
        desc: "Real estate development rooted in transparency — land, layouts and living spaces designed to appreciate in value and in trust.",
    },
    {
        id: "navayuga-healthcare",
        est: "2027",
        name: "Navayuga Healthcare",
        sector: "Pharma & Healthcare",
        logo: "/assets/logo-navayuga-healthcare-t.png",
        url: null,
        color: "#0B2B5B",
        tagline: "Science, with compassion.",
        desc: "Pharmaceutical and healthcare specialities led by clinicians — bringing global standards of care to Indian communities.",
    },
];

export const LEADERS = [
    {
        id: "chalapathi",
        name: "Chalapathi Rao Athanti",
        role: "Chief Executive Officer, MS Group",
        photo: "/assets/leader-chalapathi.jpg",
        linkedin: "https://www.linkedin.com/in/chalapathi-rao-athanti-9a630b15a/",
        creds: null,
        credsText: "MBA",
        quote: "We began with a simple promise to the Indian farmer — that our word is our bond. A decade later, that promise has grown into a group serving over a million farming families. Whatever we build next will stand on the same foundation: trust, earned season after season.",
    },
    {
        id: "mourya",
        name: "Mourya Athanti",
        role: "Executive Director, MS Group",
        photo: "/assets/leader-mourya.jpg",
        linkedin: "https://www.linkedin.com/in/mouryaathanti/",
        creds: "/assets/creds-mourya.png",
        credsText: "M.Sc. — WPI, USA · MIM — IE, Spain · BBA — VHL, Netherlands",
        quote: "Across every company, our goal is to create lasting value by blending deep-rooted values with forward-thinking leadership. We are building a group that is agile, people-centred and future-ready — one that can carry our legacy forward and scale with purpose.",
    },
    {
        id: "saranya",
        name: "Saranya Athanti",
        role: "Director, MS Group",
        photo: "/assets/leader-saranya.png",
        linkedin: "https://www.linkedin.com/in/saranya-athanti-30ab28231/",
        creds: "/assets/creds-saranya.png",
        credsText: "M.B.B.S — ESIC, Hyderabad · M.D. Paediatrics — Icahn School of Medicine at Mount Sinai, NYC",
        quote: "To me, healthcare is not a new business — it is an old promise kept in a new way. The same care with which we nurtured seeds, we now bring to nurturing lives. Every decision we take begins with one question: is it right for the patient?",
    },
];

export const TIMELINE = [
    { year: "2014", title: "The First Seed", text: "My Seeds is established — a farmer-first brand built on quality seed and honest pricing. This is where the MS Group story begins." },
    { year: "2015", title: "Absolute Trust Takes Root", text: "Navayuga Seeds is established — a research-led hybrid seed company that deepens our science and our bond with farming families." },
    { year: "2021", title: "Strength in Numbers", text: "Seven Seeds joins the portfolio, sharpening our focus on smart cultivation and high-performance hybrid varieties." },
    { year: "2023", title: "Farming, Simplified", text: "Seed Park brings seeds, agronomy and dealer networks together on one integrated platform." },
    { year: "2024", title: "Building New Ground", text: "Navayuga Ventures carries the Group into real estate — transparent, thoughtfully planned development." },
    { year: "2025", title: "A Full FMCG Basket", text: "Mega Foods is established — packaged drinking water, rice, pulses, flours, biscuits and everyday food essentials for Indian households." },
    { year: "2027", title: "Care Joins the Group", text: "Navayuga Healthcare — clinician-led pharma and healthcare specialities. Our next chapter, now in the making.", upcoming: true },
    { year: "Today", title: "One Group. Four Industries.", text: "Seven companies, one standard — a diversified Indian group being built for generations." },
];

export const VALUES = [
    { icon: "Handshake", title: "Trust Before Transactions", text: "We measure every decision against a single test — does it honour the trust placed in us by farmers, customers and partners?" },
    { icon: "Users", title: "People First, Always", text: "From the farmer in the field to the family at the dinner table, people — not quarters — sit at the centre of our businesses." },
    { icon: "Workflow", title: "Clarity & Repeatable Systems", text: "Great companies aren't run by chance. We build on clarity, people and systems that can be repeated at scale." },
    { icon: "Landmark", title: "Built for Generations", text: "We are not building for the next season. We are building institutions that our children — and India's — can be proud of." },
];

export const CONTACT = {
    office: "MS Group — Corporate Office",
    addressLines: ["5th Floor, NCL Ganga Apartments, above IDBI Bank", "Plaza, Bashirabad, Quthbullapur", "Secunderabad, Telangana 500067, India"],
    email: "team@msgroupin.com",
    phone: "+91 63039 01535",
    hours: "Monday – Saturday · 9:30 AM – 6:30 PM IST",
    mapEmbed: "https://www.google.com/maps?q=NCL%20Ganga%20Apartments,%20Quthbullapur,%20Secunderabad,%20Telangana%20500067&z=14&output=embed",
};

export const ENQUIRY_CATEGORIES = [
    "General Enquiry",
    "Business Partnership",
    "Corporate Communications",
    "Careers",
    "Business Opportunities",
];
